
import { useTheme,  } from '@mui/material/styles';
import {
    Grid, List,
    Typography,
    useMediaQuery
} from '@mui/material';



import useConfig from 'hooks/useConfig';

import { LAYOUT_CONST } from 'types/config';
import { NavItemType } from 'types/menu';
import NavItem from '../NavItem';
import TabIcon from './TabIcon';
import TabSubMenu from "./TabSubMenu";
import {Dispatch, SetStateAction, useState} from "react";
import { useSelector } from 'store';
import useAuth from 'hooks/useAuth';

interface Props {
    menuItems: NavItemType[] ;
    item: NavItemType;
    lastItem: number;
    remItems: NavItemType[];
    lastItemId: string;
    setSelectedItems: Dispatch<SetStateAction<string | undefined>>;
    selectedItems: string | undefined;
    setSelectedLevel: Dispatch<SetStateAction<number>>;
    selectedLevel: number;
  }


const TabLayout = ({ menuItems,setSelectedItems,selectedItems,setSelectedLevel,selectedLevel,remItems,lastItemId,lastItem,item }: Props) => {
  const theme = useTheme();
  const {user}= useAuth();
  const { menuOrientation } = useConfig();
    const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItem,setSelectedItem]=useState<any>(item);
  const downLG = useMediaQuery(theme.breakpoints.down('lg'));
    const tabPanel=menuItems.map((itemEle) => {
      // console.log(itemEle?.permissions,user?.permissions?.includes(itemEle?.permission));
      const elePermissions = user?.permissions?.filter((value:any) => itemEle?.permissions?.includes(value));

      if(!itemEle.permissions || 0<elePermissions?.length){
       
          switch (itemEle.type) {
            case 'group':
              return (
                <>
                <TabIcon item={itemEle} selected={selectedItem==itemEle} setSelectedGroup={setSelectedItem}/>
                </>
  
              );
            case 'item':
              return <NavItem key={itemEle.id} item={itemEle} level={1} />;
            default:
              return (
                <Typography key={itemEle.id} variant="h6" color="error" align="center">
                  Fix - Navigation Group
                </Typography>
              );
         
        }
      }
     
      });
      // console.log(user?.permissions)
    const selectedGroup=
        (selectedItem)? <TabSubMenu
                key={selectedItem?.id}
                setSelectedItems={setSelectedItems}
                setSelectedLevel={setSelectedLevel}
                selectedLevel={selectedLevel}
                selectedItems={selectedItems}
                lastItem={lastItem!}
                remItems={remItems}
                lastItemId={lastItemId}
                item={selectedItem}
            />: <></>



  return (
    <>
      {menuOrientation === LAYOUT_CONST.VERTICAL_LAYOUT || downLG ? (
       <> 
       <Grid container spacing={2} mt={drawerOpen? '15px':0} sx={{px:2,height:'calc(100vh - 115px)'}} direction={'row'} xs={12} justifyContent={"flex-start"} >
           <Grid  item container direction="column" xs={4}  borderRight= {drawerOpen? `1px solid ${theme.palette.grey["300"]}`: 'none'} spacing={2} justifyContent={"flex-start"} >
               <List>
                {tabPanel}
               </List>
           </Grid>
           {drawerOpen? <Grid item container direction="column" xs={8} alignItems={"center"} spacing={2} style={{height: "100%"}}>
               {selectedGroup}
           </Grid>:<></>}
         </Grid>
       </>
      ) : (<></>      )}
    </>
  );
};

export default TabLayout;
